import styled from "styled-components";

export const ListingDataWrapper = styled.div`
    padding: 0 0 20px;
    .expand-collapse-class{
        display: flex;
        h4{
            background: #005586;
            padding: 0px;
            width: 17px;
            border-radius: 50%;
            height: 16px;
            margin: 3px 0px 0px 0px;
            cursor: pointer;
            i {
                border: solid #ffff;
                border-width: 0 2px 2px 0;
                display: inline-block;
                padding: 2px;
                margin: 0px 0px 13px 6px;
                transform: rotate(-135deg);
                -webkit-transform: rotate(-135deg);
            }
        }  
        h5{
            background: #005586;
            padding: 0px;
            width: 16px;
            border-radius: 50%;
            height: 16px;
            margin: 6px 0px 0px 0px;
            cursor: pointer;
            i {
                border: solid #ffff;
                border-width: 0 2px 2px 0;
                display: inline-block;
                padding: 2px;
                margin: 0px 0px 13px 5px;
                transform: rotate(45deg);
                -webkit-transform: rotate(45deg);
            }
        }
    }
    .remark{
        word-wrap: break-word;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        max-width: 125px;
    }
    .order-details-wrapper-heading{
        h6{
            font-size: 13px;
            font-weight: bold;
        }
    }
    .user-list-table-styles td, table tr th{
        font-size: 14px;
        padding: 0.45rem 0.75rem;
        vertical-align: middle;
    }
    .order-details-wrapper{
        td, th{
            border: none;
            padding: 0.45rem 0.75rem;
            vertical-align: middle;
        }
        h6{
            font-size: 13px;
            font-weight: bold;
        }
        p{
            font-size: 14px;
        }
        .print-tag-style{
            border: 1px solid #E5E5E5;
            padding: 3px 10px 4px;
            white-space:nowrap;
            border-radius: 3px;
            background: #fff;
        }
        .get-flat-fee-button-class{
          white-space: nowrap;
          border: none;
          border-radius: 5px;
          background: #005586;
          color: #fff;
          height: 30px;
          font-size: 14px;
        }
    }
    .custom-select-input{
        border-bottom:1px solid rgb(225,225,225)
    }
`;

export const FormWrapper = styled.div`
    padding: 5px 10px;
    background: #FFFFFF;
    border: 1.5px solid #87cdf1;
    max-height: calc(60vh - 20px);
    // min-height: 100vh;
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-bottom:14px;
    label{
        font-size: 14px;
        color: rgb(0,85,134);
        font-weight: bold;
    }
    
`

export const BackButtonWrapper = styled.div`
float:left;
.back-button {
    background: #005586;
    padding: 5px;
    width: 68px;
    border-radius: 5px;
    color: #fff;
    border: none;
    margin-top: 10px;
}
`;

export const TableFormRowWrapper = styled.div`
    background: #FFFFFF;
    border-radius: 0;
    min-height: auto;
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 5px 10px;
    .custom-select-input{
        border: 1px solid rgb(225, 225, 225);
        border-radius: 0px;
        padding: 0px;
        font-size: 13px !important;
    }
    .custom-select-input:hover{
        border: 1px solid rgb(225, 225, 225);
    }
    .custom-select-input::placeholder, .css-1dxmcrj-placeholder {
        font-size: 13px !important;
    }
    .custom-select-input .custom-select__value-container .custom-select__input input[type="text"]{
        width: 280px !important;
    }
    .items-row-wrapper {
        .input-container {
            position: relative;
            display: flex;
            flex-direction: column;
        }
        .label-heading {
            font-weight: bold;
            font-size: 13px;
            line-height: normal;
            letter-spacing: 0.005em;
            color: rgb(0, 85, 134);
            margin-bottom: 10px;
        }
        button.save-item {
            width: 100%;
            max-width: 75px;
            margin: 0 auto;
            height: 36px;
            border-radius: 5px;
            background: linear-gradient(180deg, #61b01f 0, #27911b) !important;
            font-size: 13px !important;
            border: 0;
            color: #fff;
        }
        button.save-item:disabled {
            cursor: default;
            opacity: 0.4;
        }
        input, select, .file-input-wrapper .MuiFormControl-root,.app-input-text textarea, #pickupPalletType > div, #vendorLocationId > div {
            border: none;
            border-bottom: 1px solid #010101;
            border-radius: 0;
            padding: 0;
            font-size:13px;
        }
        .file-input-wrapper .MuiFormControl-root{
            padding: 8px 2px;
            height: auto;
        }
        .file-input-wrapper.disabled-datepicker .MuiFormControl-root{
            background: #f2f2f2;
        }
        .css-1okebmr-indicatorSeparator{
            width:0px;
        }
        .app-input-text textarea {
            resize: none;
            padding: 8px 0;
            height: auto;
            overflow-x: auto;
            white-space: nowrap;
            margin-bottom: -5px;
        }
    
        .app-input-text{
            margin-bottom:0;
        }
        .app-input-text.number-format-input-styles{
            max-width: 100px;
        }
        .file-input-wrapper .MuiFormControl-root .MuiInput-root{
            padding:0;
        }
        .file-input-wrapper .MuiFormControl-root .MuiInput-root input{
            border-bottom: none;
            padding-bottom:5px;
        }
        .add-more{
            background:#005586;
            color: #fff;
            padding: 5px 7px 5px 9px;
        }
        .add-more.remove{
            background: none;
            color: #fff;
            padding: 5px 7px 5px 9px;
            border: 0;
        }
        .error-message{
            font-size: 9px !important;
        }
    }
    .items-row-wrapper.grid-view {
        display: grid;
        align-items: flex-end;
        grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr 2fr 0.5fr;
        gap: clamp(10px, 2.083vw, 10px);
        margin-bottom: 16px;
        input, select, .file-input-wrapper .MuiFormControl-root,.app-input-text textarea, #pickupPalletType > div, #vendorLocationId > div {
            border-bottom: 1px solid #e1e1e1;
        }
        .error-message{
            position: absolute;
            font-size: 9px !important;
        }
    }
    button.app-green-button {
        width: 100%;
        max-width: 150px;
        margin: 0 auto;
        height: 36px;
        border-radius: 5px;
        background: linear-gradient(180deg, #61b01f 0, #27911b) !important;
        font-size: 14px !important;
    }
    button.add-buyback-fee{
        background: #005586;
        color: white;
        border: 0;
        border-radius: 5px;
        padding: 7px 15px;
        margin: 2px;
        font-size: 14px;
    }
    button.add-buyback-fee:disabled {
        background-color: #ccc; /* Gray background color */
        color: #666; /* Darker gray text color */
        cursor: not-allowed; /* Change cursor to not-allowed when disabled */
    }

`

export const ItemsRowsWrapper = styled.div`
`

export const FilterWrapper = styled.div`
    display: grid;
    align-items: center;
    width: 100%;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    gap: 12px;
    .filter-item-box{
        text-align: end;
    }
    .MuiIconButton-label{
        color: #fff;
    }
    .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track{
        background-color: rgb(0, 85, 134);
        opacity: 1;
    }
    .export-btn{
        font-size: 1rem;
        font-weight:bold;
        cursor: pointer;
        width:100%;
        svg{
            background: #fff;
            width: 32px;
            height: 32px;
            padding: 4px;
            margin-left: 5px;
        }
    }
`
export const Heading = styled.div`
    display: grid;
    align-items: center;
    background-color: #87cdf1;
    padding: 5px 16px;
    min-height: 55px;
    gap: 10px;
    border-radius: 15px 15px 0 0;
    grid-template-columns: 1fr 7fr;
    h3 {
        font-size: 18px;
        color: #000;
        font-family: "latosemibold";
    }
`
export const SearchWrapper = styled.div`
  display: flex;
  position: relative;
  border-radius: 4.2px;
  overflow: auto;
  max-width: 260px;
  min-width: 200px;
  width: 100%;
  justify-content: end;
  margin: 3px;
  input {
    background: #ffffff;
    border: 1px solid #87cdf1;
    padding: 4px 35px 4px 15px;
    width: 100%;
    border-radius: 4px;
    height: 36px;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #00000087;
    }
    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #00000087;
    }
    ::placeholder {
      color: #00000087;
    }
  }
  svg {
    position: absolute;
    right: 12px;
    top: 12px;
    color: #525e66;
    font-size:20px
  }
`
export const VendorPricingAddModal = styled.div`
  .modal-body {
    padding: 0 !important;
  }
  .main-header{
      display: flex;
      justify-content: space-between;
      padding: 15px;
      background: #005586;
      h4{
          font-family: 'latomedium';
          font-size: 18px;
          width: 95%;
          text-align: center;
          color: #fff;
      }
      img{
          height: 18px;
          width: 18px;
          background: #fff;
          border-radius: 50%;
          padding: 2px;
          cursor: pointer;
      }
  }
  .new-data-add-section-style{
    padding: 15px;
    .outer-wrapper{
      display: flex;
      flex-direction: column;
      gap: 20px;
      padding: 15px;
      border: 1px solid #e9e9e9;
      box-shadow: 0px 4px 15px 0px #00000026;
      .error-message{
        font-size: 11px;
        color: red;
        margin: 0px;
      }
      .top-row-style{
        display: flex;
        gap: 15px;
      }
      .hardSoftWood-styles{
        display: flex;
        gap: 10px;
        margin-top: 5px;
        .radio-container{
            padding: 3px 0px 0px 28px;
            .radio-checkmark:after{
              width: 12px;
              height: 12px;
            }
        }
        .check-disabled{
          .radio-checkmark{
            background: grey;
            border: none;
          }
        }
        .checkbox-field  {
            margin: 0px !important;
        }
        .radio-checkmark{
          border-radius: 0%;
          height: 18px;
          width: 18px;
          top: 6px;

        }
      }
      .pallet-details-row-style{
        display: flex;
        gap: 15px;
      }
      .custom-size-styles{
        display: flex;
        gap: 15px;
        .app-input-text{
          margin-bottom: 0;
        }
      }
      .checkbox-field{
        align-items: end;
        margin: 0;
        height: 36px;
      }
      .checkbox-container{
        white-space: nowrap;
      }
      .vendor-pricing-style{
        display: flex;
        gap: 15px;
        .text-area-style{
          height: 38px;
          .app-input-text{
            width: 250px;
          }
        }
        .app-input-text{
          margin-bottom: 0;
        }
        .file-input-wrapper .MuiFormControl-root{
          height: 38px;
        }
        .disable-date-style .file-input-wrapper .MuiFormControl-root{
          border: solid 1px #e6e6e6;
          background: #f2f2f2;
        }
        textarea{
          height: 38px;
          border-radius: 5px;
          border: solid 1px #87cdf1;
          width: 200px;
          background: #fff;
          padding: 6px 14px;
          color: #191819;
          resize: none;
        }
      }
      .add-button-style{
        text-align: center;
        button{
          background: #004A79;
          color: #fff;
          height: 35px;
          border-radius: 5px;
          border: none;
          width: 70px;
        }
      }
      .number-div-style{
        height: 37px;
        border-radius: 5px;
        border: solid 1px #e6e6e6;
        width: 200px;
        background: #f2f2f2;
        padding: 6px 14px;
        color: #191819;
      }
      .checkbox-styles-disable-view {
        display: flex;
        align-items: end;
        height: 38px;
        white-space: nowrap;
      }

      .checkbox-styles-disable-view input[type="checkbox"] {
        width: 22px;
        height: 22px;
        margin-right: 8px;
        appearance: auto;
      }

      .checkbox-styles-disable-view label {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #333;
        margin-right: 10px;
      }
    }
    .table-wrapper{
      max-height: 400px;
      overflow-y: auto;
      table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 20px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }
      th, td {
          padding: 12px;
          text-align: left;
      }
      th {
          background-color: #f9f9f9;
          font-family: 'latosemibold';
      }
      tbody{
        tr{
          border-bottom: 1px solid #ffffff;
          box-shadow: 0px 4px 10px 0px #00000026;
        }
      }
      .actions {
          display: flex;
          justify-content: center;
      }
      .icon {
          margin: 0 5px;
          cursor: pointer;
      }
      .submit-button-style{
        text-align: center;
        margin-top: 15px;
        button{
          background: linear-gradient(90deg, #55C416 0%, #367910 100%);
          color: #fff;
          height: 35px;
          border-radius: 5px;
          border: none;
          width: 90px;
        }
      }
    }   
  }
`
export const FlatFeeLisitngModalWrapper = styled.div`
  .modal-body {
    padding: 0 !important;
  }
  .main-header{
      display: flex;
      justify-content: space-between;
      padding: 15px;
      background: #005586;
      h4{
          font-family: 'latomedium';
          font-size: 18px;
          width: 95%;
          text-align: center;
          color: #fff;
      }
      img{
          height: 18px;
          width: 18px;
          background: #fff;
          border-radius: 50%;
          padding: 2px;
          cursor: pointer;
      }
  }
  .pallet-details-style{
    display: flex;
    align-items: baseline;
    padding: 15px 25px 0px 25px;
    p{
      font-family: 'latobold';
      margin-right: 10px;      
      white-space: nowrap;
    }
  }
  .table-wrapper{
    max-height: 400px;
    overflow-y: auto;
    padding: 0px 25px 25px 25px;
    table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 15px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    th, td {
        padding: 12px;
        text-align: left;
    }
    th {
        background-color: #f9f9f9;
        font-family: 'latosemibold';
    }
    tbody{
      tr{
        border-bottom: 1px solid #ffffff;
        box-shadow: 0px 4px 10px 0px #00000026;
      }
    }
  }
`